import { Suspense } from 'react'

export const withSuspense = (WrappedComponent: any) => {
  return function (props: any) {
    return (
      <Suspense fallback={null}>
        <WrappedComponent {...props} />
      </Suspense>
    )
  }
}
